





































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import  ContabilContaPagarService  from "@/service/ContabilContaPagarService";
import {OrdemPagamentoPrestadorModel} from "@/models/contabil/contas-pagar/OrdemPagamentoPrestadorModel";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import moment from "moment";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog
  }
})
export default class OrdemPagamentoPrestador extends Vue {

  listaFiltroStatus = [
    { name: "APROVADA", descricao: "Aprovada" },
    { name: "ENVIADA_PAGAMENTO", descricao: "Enviada Pagamento" },
    { name: undefined, descricao: "Todas" },
  ]

  status = {
    name: "APROVADA", 
    descricao: "Aprovada"
  };

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  dialogKey = 0;


  listaContasPagar = [] as OrdemPagamentoPrestadorModel[];

  loading:boolean = false;

  mounted() {
    this.buscarContasAprovadas();
    this.status = {
      name: "APROVADA", 
      descricao: "Aprovada"
    }
  }

  acaoDialog() {
      this.openDialog = false;
  }

  buscarContasAprovadas() {
     ContabilContaPagarService.listarContaPagarStatusAprovada().then(res => {
        this.listaContasPagar = res.data;
    })
  }

  filtrar() {
    ContabilContaPagarService.filtrarContasPagarPorStatusAprovadaEEnviadaPagamento(this.status).then(res => {
      this.listaContasPagar = res.data;
    })
  }


   cabecalho = [
        { text: "CNPJ", value: "cnpj", width: "15%", align:'center', divider:true },
        { text: "Inscrição municipal", value: "inscricaoMunicipal", width: "10%", divider:true },
        { text: "Número NF", value: "numeroNF", width: "10%", divider:true},
        { text: "Valor bruto", value: "valorBruto", width: "15%", divider:true},
        { text: "Desconto incondicional", value: "descontoIncondicional", width: "10%", divider:true },
        { text: "Impostos", value: "impostos", sortable: false,  width: "10%", divider:true },
        { text: "Valor líquido", value: "valorLiquido", sortable: false,  width: "10%", divider:true },
        { text: "Status", value: "status", sortable: false,  width: "10%", divider:true },
        { text: "Download NF", value: "download", sortable: false,  width: "5%" , align:'center', divider:true  },
        { text: "Gerar ordem pagamento", value: "actions", sortable: false,  width: "15%", align:'center', divider:true  },
       
    ];

    gerarPagamento() {
    
    this.loading = true;
    let idsSelecionados = [] as number[];
      
      for (const conta of this.listaContasPagar) {
            if(conta.selecionado) {
              idsSelecionados.push(conta.idContaPagar);
            }
      }
      ContabilContaPagarService.gerarPagamentos(idsSelecionados).then(res => {
        this.filtrar();
        this.loading = false;

        let fileURL = window.URL.createObjectURL(new Blob([res.data]));

        let fileLink = document.createElement('a');

        fileLink.href = fileURL;

        fileLink.setAttribute('download', `cnab.txt`);

        document.body.appendChild(fileLink);

        fileLink.click();

      })
    }

    downloadNotaFiscal(nomeArquivo:string) {
        ContabilContaPagarService.downloadNotaFiscal(nomeArquivo).then(res => {
                
                let fileURL = window.URL.createObjectURL(new Blob([res.data]));

                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.setAttribute('download', `nota-fiscal_${moment().format('MMMM Do YYYY, h:mm:ss')}.pdf`);

                document.body.appendChild(fileLink);

                fileLink.click();
        }).catch(err => {
            this.dialogTitle = "Aviso";
            this.dialogMessage = "Não possui arquivo nota fiscal para download."
            this.dialogStyle = "";
            this.openDialog = true;
        });
    }
    
}
